module.exports = __webpack_public_path__ + "static/media/nu.e8eb396e.svg";